export const getNumberInRange = ({ value, min, max }: { value: number; min?: number; max?: number }) => {
  const minValue = min === undefined ? -Infinity : min;
  const maxValue = max === undefined ? Infinity : max;
  return Math.max(minValue, Math.min(maxValue, value));
};
